import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {activeFilter, dateFilter} from "../../../utils/filters";

class PromotionList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "PromotionList"}
                {...props}
                columns={{
                    [componentConfig.idfield]: {header: 'Kód', width: 1, sortable, filterable},
                    "name": {header: 'Név', width: 6, sortable, filterable},
                    "active": {header: 'Aktív', width: 1, sortable, filterable: activeFilter(), renderer: (value, row) => value + "" === "1" ? "Aktív" : "Inkatív"},
                    "start_date": {header: 'Kezdés', width: 2, sortable, filterable: dateFilter()},
                    "end_date": {header: 'Vég', width: 2, sortable, filterable: dateFilter()},
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default PromotionList;
